import React from "react";

const EmbedSize = ({ size, adjustment }) => {
  const { height = 100 } = size;
  const { height: adjustmentHeight = 10 } = adjustment;

  if (window?.parent && (height + adjustmentHeight) > 100) {
    const messageObject = {
      sentinel: 'amp',
      type: 'embed-size',
      height: Math.round(height + adjustmentHeight),
    };
    window.parent.postMessage(messageObject, '*');
  }

  return (
    <></>
  );
}

export default EmbedSize;